import { Map, List } from 'immutable';

import { groupAvailByRoom, getAvailStore } from './availUtils';

import { ParamsContext } from '@synergycms_core/utils/paramsParser';
import actions from '@synergycms_app/store/actions';
import { getLoyaltyTier } from '../customer/loyaltyUtils';

export default {
  RESET_AVAIL: () => {
    return (dispatch, getState) => {
      const store = getState();
      return store.getIn(['customer', 'current_hotel']);
    };
  },
  GET_FLEXIBLE_ASYNC: (group, hotelIds, alternatives) => (dispatch, getState) => {
    return dispatch(actions.avail.getAvailCustomAsync({ group, hotelIds, flexible: true, alternatives }));
  },
  GET_AVAIL_ASYNC: (group, hotelIds, alternatives) => (dispatch, getState) => {
    return dispatch(actions.avail.getAvailCustomAsync({ group, hotelIds, alternatives }));
  },
  GET_AVAIL_CUSTOM_ASYNC:
    ({ group = false, forcedRate, hotelIds = [], flexible = false, alternatives = true }) =>
    (dispatch, getState) => {
      const rate = getState().getIn(['customer', 'avail_type_selected']);
      const activeLoyalty = group
        ? getState().getIn(['customer', 'loyalty', 'descriptives', group, 'loyalty'], null)
        : getState().getIn(['customer', 'loyalty', 'data', 'loyalty']);
      let params = getState().getIn(['customer', 'params', 'params']);

      const availType = activeLoyalty?.size && (group || rate === 'loyalty') ? 'loyalty' : 'standard';

      if (activeLoyalty?.size) {
        const loyaltyTier = getLoyaltyTier(getState());
        params = params.set('loyalty', loyaltyTier);
      }

      const managerParams = new ParamsContext(
        params,
        availType,
        (params) => dispatch(actions.hotels.setLastQueryParams(params)),
        !!alternatives
      );
      
      return dispatch(getAvailStore(managerParams, flexible, hotelIds, alternatives)).then((res) => {
        return res;
      });
    },
  GET_AVAIL_PARSED: () => {
    return (dispatch, getState) => {
      const store = getState();
      const avail = store.get('avail');
      const currentHotel = store.getIn(['customer', 'current_hotel']).toString();
      return (
        avail &&
        avail
          .filter((_, hotelId) => currentHotel === hotelId)
          .reduce((parsedAvail, hotelAvail, hotelId) => {
            const promotionCode = store.getIn(['customer', 'params', 'url_params', 'promotion_code'], false);
            const roomsCustomOrder = store
              .getIn(['hotels', hotelId, 'rooms_order'], List())
              .sortBy((b) => b.get('weight'));
            const serviceQueryParams = store.getIn(['hotels', hotelId, 'params', 'service_query_params']);
            const serviceAvail = store.getIn(['availServices', hotelId, serviceQueryParams, 'response']);

            const hotelQueryParams = store.getIn([
              'hotels',
              hotelId,
              'params',
              store.getIn(['availQuery', 'mono', 'query_params'])
            ]);
            //const flexibleQueryParams = store.getIn(['hotels', hotelId, 'params', `${key}_query_params`]);
            let storeKey = [hotelId, hotelQueryParams, 'response'];

            if (!hotelQueryParams || avail.getIn(storeKey)) {
              return parsedAvail;
            }
            console.log(hotelId + ' parsed', hotelQueryParams);
            let availResponse = hotelAvail.getIn([hotelQueryParams, 'raw_response']);
            let availFlexibleResponse = hotelAvail.getIn([hotelQueryParams, 'flexible_raw_response']);

            let rawAvail = hotelAvail.getIn([hotelQueryParams, 'has_avail']) && availResponse;
            let rawAvailFlexible = hotelAvail.getIn([hotelQueryParams, 'flexible_has_avail']) && availFlexibleResponse;

            if (!rawAvail && !rawAvailFlexible) {
              return (parsedAvail = parsedAvail.setIn(storeKey, Map({ success: false })));
            }

            parsedAvail = parsedAvail.setIn(
              storeKey,
              groupAvailByRoom(rawAvail, serviceAvail, roomsCustomOrder, rawAvailFlexible, promotionCode)
            );

            return parsedAvail;
          }, new Map())
      );
    };
  },
  SET_RELATED_AVAIL: () => {
    return (dispatch, getState) => {
      const store = getState();
      const webType = store.getIn(['customer', 'web_type'], false);
      if (webType !== 'PORTAL') return;

      const hotelId = store.getIn(['customer', 'current_hotel']);
      const roomsAvail = store.getIn(
        [
          'avail',
          hotelId,
          store.getIn(['hotels', hotelId, 'params', store.getIn(['availQuery', 'mono', 'query_params'])])
        ],
        Map()
      );

      if (roomsAvail.get('has_avail')) return;

      const params = store.getIn(['customer', 'params', 'params'], undefined);
      const group = store.get('group', false);
      const city =
        webType !== 'WI' &&
        params &&
        params.get('city_id') &&
        store.getIn(['hotels', 'hotels_info', 'cities']).find((city) => {
          return city.get('id') === parseInt(params.get('city_id'), 10);
        });
      if (!city) return;

      let cityId = city.get('id');
      var hotelIds = store
        .getIn(['hotels'])
        .getIn(['hotels_info', 'hotels'])
        .filter((h) => h.get('city_id') === cityId && h.get('id') !== hotelId)
        .toJS()
        .reduce((hotelsCity, hotel) => hotelsCity.concat([hotel.id]), List());

      return Promise.all([
        dispatch(actions.hotels.getAsync(hotelIds)),
        dispatch(actions.customer.loyalty.getDescriptiveAsync(group)).then(() => {
          return dispatch(actions.avail.getAvailAsync(group, hotelIds, false));
        })
      ]);
    };
  },
  CLEAR: () => {}
};
